import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { Table, Pagination, PagingQuery } from 'tea-component';
import Loading from '@/pages/intelligence/components/Loading';
import { useIntl } from 'umi';
const { scrollable, expandable } = Table.addons;

interface TopchartTableProps {
  loading: boolean;
  records: any[];
  columns: any[];
  tableTotal: number;
  pageIndex: number;
  pageSize: number;
  onPagingChange: (e: PagingQuery) => void;
  recordKey: string;
  isExpandable?: boolean;
  expandableAddon: any;
  observeTableSize?: (width: number) => void;
  pageSizeOptions?: number[];
  className?: string;
}
export default function FixedSubTable(props: TopchartTableProps) {
  const {
    loading,
    records,
    columns,
    tableTotal,
    pageIndex,
    pageSize,
    onPagingChange,
    recordKey,
    pageSizeOptions = [20, 50, 100],
    isExpandable = true,
    expandableAddon,
    observeTableSize,
    className,
  } = props;

  // console.log('FixedSubTable', props);
  const { formatMessage } = useIntl(); // 中英切换方法

  const loadingOrNodata = loading || !records?.length;
  const addons = (() => {
    const addonsTemp = [
      scrollable({
        minWidth: 'auto',
        maxHeight: '100%',
        minHeight: loadingOrNodata ? '158px' : 'auto',
      }),
    ];
    if (isExpandable) {
      addonsTemp.push(expandable({ ...expandableAddon }));
    }
    return addonsTemp;
  })();

  const tableRef = useRef<HTMLTableElement>(null);
  const resizeChange = (entry: any) => {
    const width = entry?.contentRect?.width;
    observeTableSize(width - 40);
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      if (!Array.isArray(entries) || !entries?.length) {
        return;
      }
      for (const entry of entries) {
        resizeChange(entry);
      }
    });
    const tbodyDom = document.querySelector('.sub-table-fixed .tea-table__body');
    if (tbodyDom !== null) {
      resizeObserver.observe(tbodyDom);
      return (): void => {
        resizeObserver.unobserve(tbodyDom);
      };
    }
  }, []);

  return (
    <div style={{ position: 'relative' }} className={classnames('', className)}>
      {/* 添加覆盖NoData，不随表格滚动 */}
      <div
        style={{
          display: loading || records.length === 0 ? 'block' : 'none',
          position: 'absolute',
          // width: '100%',
          width: '-webkit-fill-available',
          zIndex: 9999,
          textAlign: 'center',
          bottom: 122,
        }}
      >
        {loading ? <Loading /> : records.length === 0 ? formatMessage({ id: 'common_nodata' }) : ''}
      </div>
      <Table
        recordKey={recordKey}
        ref={tableRef}
        // className="dbi-mobileGames-table sub-table-fixed dbi-mobile-table"
        className="dbi-mobileGames-table sub-table-fixed dbi-table-sticky"
        bordered="all"
        records={Array.isArray(records) ? records : []}
        columns={columns}
        addons={addons}
      />
      <Pagination
        pageSizeOptions={pageSizeOptions}
        onPagingChange={(e) => {
          if (onPagingChange instanceof Function) {
            onPagingChange(e);
          }
        }}
        pageSize={pageSize}
        pageIndex={pageIndex}
        recordCount={tableTotal}
        stateTextVisible={true}
        pageSizeVisible={tableTotal > pageSizeOptions?.[0]}
        pageIndexVisible={tableTotal > pageSizeOptions?.[0]}
        jumpVisible={tableTotal > pageSizeOptions?.[0]}
        endJumpVisible={tableTotal > pageSizeOptions?.[0]}
        stateText={formatMessage({ id: 'dbi_pagination_total' }, { total: tableTotal ?? 0 })}
      />
    </div>
  );
}
